import {IUserGeoLocationAds} from "modules/reducers/ads";
import {createAction} from "redux-act";

export const userGeoLocationAds = createAction();
export const userGeoLocationAdsSuccess = createAction<IUserGeoLocationAds>();
export const userGeoLocationAdsFailed = createAction();
